import modes from "@gotombola/react-ds/lib/template-modules/custom";

export default {
    campaign: {
        modules: {},
        custom: {
            modes,
        }
    }
}